export enum CryptoDonationStatus {
  Pending = 'pending',
  Synced = 'synced',
}

export default CryptoDonationStatus;
